// src/constants/menu/controlMenu.ts
import { SidebarNavigationItem } from '@app/components/layouts/main/sider/sidebarNavigation';
import { RootState } from '@app/store/store';
import { BaseImage } from '@app/components/common/BaseImage/BaseImage';
import UserManagementIcon from "assets/menus/master-maintenance/user-management-1.svg";
import SelectedUserManagementIcon from "assets/menus/master-maintenance/user-management.svg";
import { REPORT_MENU } from '@app/constants/menu/reportMenu';
import ReportingMenuIcon from "assets/menus/master-maintenance/business-intelligence-management-1.svg";
import SelectedReportingMenuIcon from "assets/menus/master-maintenance/business-intelligence-management.svg";
import ItemSettingsIcon from "assets/menus/master-maintenance/item-settings-1.svg";
import SelectedItemSettingsIcon from "assets/menus/master-maintenance/item-settings.svg";
export const CONTROL_MENU = (state: RootState): SidebarNavigationItem[] => [
  ...REPORT_MENU(state),
  {
    title: 'shortcutMenus.userManagement.title',
    key: 'userManagement',
    icon: <BaseImage src={UserManagementIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedUserManagementIcon} preview={false} />,
    url: '/shortcut/user-management',
  },
  {
    title: 'shortcutMenus.itemSettings.title',
    key: 'itemSettings',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/item-settings',
  },
   {
    title: 'shortcutMenus.factoryPrinting.title',
    key: 'factoryPrinting',
    icon: <BaseImage src={ItemSettingsIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedItemSettingsIcon} preview={false} />,
    url: '/shortcut/factory-printing',
  },
  {
    title: 'shortcutMenus.reportConfiguration.title',
    key: 'reportConfiguration',
    icon: <BaseImage src={ReportingMenuIcon} preview={false} />,
    selectedIcon: <BaseImage src={SelectedReportingMenuIcon} preview={false} />,
    url: '/shortcut/report-configuration',
  }
  // …more control-only menu items
];
